module.exports = "https://cwa.roocdn.com/_next/static/rider-default.40700e4d.png";